var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { device } from '../../breakpoints';
import { LogoClickableWrapper } from './LogoClickableWrapper';
import { LogoImage } from './LogoImage';
var LogoContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-block: 0.75rem;\n  display: block !important;\n  height: 72px;\n  box-sizing: border-box;\n\n  @media ", " {\n    padding-block: 0;\n    height: 40px;\n    padding: 0 0.5rem;\n  }\n"], ["\n  padding-block: 0.75rem;\n  display: block !important;\n  height: 72px;\n  box-sizing: border-box;\n\n  @media ", " {\n    padding-block: 0;\n    height: 40px;\n    padding: 0 0.5rem;\n  }\n"])), device.laptop);
export var Logo = function (props) {
    return (React.createElement(LogoContainer, null,
        React.createElement(LogoClickableWrapper, __assign({}, props.clickProps),
            React.createElement(LogoImage, __assign({}, props.imageProps)))));
};
var templateObject_1;
